export const colors = {
  bgColor: '#F3F5F9',
  linkColor: '#383b3e',
  scrollbarThumbColor: '#999999',

  tableHeaderTextColor: '#808080',
  red: '#d32f2f',
  lime: '#B8E900',
  grey: '#F3F5F9',
  green: '#bff22e',
  black: '#000000',
  white: '#ffffff',
  darkRed: '#800000',
  darkGrey: '#787878',
  lightPink: '#ffd9d9',
  darkGreen: '#00A67D',
  lightGrey: '#F3F3F3',
  lightBlack: '#282828',
  middleGrey: '#e0e2e5',
  success: 'lightseagreen',
  transparent: 'transparent',
};
